import * as React from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Cookies from 'js-cookie';

const propTypes = {
  onClick: PropTypes.func,
  onClickEPG: PropTypes.func,
  select: PropTypes.bool,
  group: PropTypes.string,
  title: PropTypes.string,
  logo: PropTypes.string,
  _id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  url: PropTypes.string,
  ch: PropTypes.string,
  ext: PropTypes.string,
  epg: PropTypes.string,
};

const defaultProps = {
  onClick: null,
  onClickEPG: null,
  select: false,
  group: '',
  title: '',
  logo: null,
  _id: null,
  url: null,
  ch: null,
  ext: null,
  epg: null,
};

const ChannelListItem = props => {
  const {
    onClick,
    onClickEPG,
    select,
    group,
    title,
    logo,
    _id,
    url,
    ch,
    ext,
    epg,
  } = props;
  return (
    <div className={classnames('channel-listitem', { select })}>
      <ButtonBase
        color="default"
        classes={{ root: 'list--item-container' }}
        onClick={() => {
          if (typeof onClick === 'function') {
            const cookie = Cookies.get('TIME_AUTH')
            onClick(_id, `${url}/${ch}/${ext}?token=${cookie}`);
          }
        }}
      >
        <div
          alt={title}
          className="btn--logo-img"
          style={{
            backgroundImage: `url(${
              process.env.PUBLIC_URL
              }/logos/${group}/${logo})`,
          }}
        />
      </ButtonBase>
      {/* {group === '1_tv' && (
        <ButtonBase
          classes={{
            root: 'list--item-action',
          }}
          onClick={() => {
            if (typeof onClickEPG === 'function') {
              onClickEPG(_id, epg);
            }
          }}
        >
          <i className="ic--epg" />
        </ButtonBase>
      )} */}
    </div>
  );
};
ChannelListItem.propTypes = propTypes;
ChannelListItem.defaultProps = defaultProps;

export default ChannelListItem;
